import { useIsMobile } from '@energiebespaarders/hooks';
import { Box, Flex } from '@energiebespaarders/symbols';
import { Heading, Small } from '@energiebespaarders/symbols/helpers';
import { themify } from '@energiebespaarders/symbols/styles/mixins';
import { MONTHS } from '~/utils/constants';

const Natuurkalender: React.FC = () => {
  const isMobile = useIsMobile();
  const colorsByMonth: Record<(typeof MONTHS)[number], { firstHalf: string; secondHalf: string }> =
    {
      Januari: { firstHalf: 'orange', secondHalf: 'orange' },
      Februari: { firstHalf: 'orange', secondHalf: 'orange' },
      Maart: { firstHalf: 'yellow', secondHalf: 'green' },
      April: { firstHalf: 'red', secondHalf: 'red' },
      Mei: { firstHalf: 'red', secondHalf: 'red' },
      Juni: { firstHalf: 'red', secondHalf: 'red' },
      Juli: { firstHalf: 'red', secondHalf: 'red' },
      Augustus: { firstHalf: 'green', secondHalf: 'green' },
      September: { firstHalf: 'green', secondHalf: 'green' },
      Oktober: { firstHalf: 'green', secondHalf: 'green' },
      November: { firstHalf: 'yellow', secondHalf: 'orange' },
      December: { firstHalf: 'orange', secondHalf: 'orange' },
    };

  return (
    <Flex flexWrap="wrap" mx={['-3px', '-3px', -1]}>
      <Box width={1} px={['3px', '3px', 1]}>
        <Heading heading="h5">Natuurkalender</Heading>
      </Box>
      {MONTHS.map((month, i) => (
        <Box key={`${month}-${i}`} width={1 / 6} px={['3px', '3px', 1]}>
          <Box
            p={1}
            style={{
              background: themify('grayLight'),
              whiteSpace: 'nowrap',
              height: '2em',
              fontWeight: 500,
              lineHeight: '1em',
            }}
            textAlign="center"
          >
            {isMobile ? month.slice(0, 3) : month}
          </Box>
          <Flex width={1} height="2em" flexWrap="wrap">
            <Box
              width={1 / 2}
              style={{
                background: themify(colorsByMonth[month].firstHalf),
                borderRight: '1px solid white',
                height: '2em',
              }}
            />
            <Box
              width={1 / 2}
              style={{ background: themify(colorsByMonth[month].secondHalf), height: '2em' }}
            />
          </Flex>
        </Box>
      ))}
      <Box width={1} px={1} mt={1}>
        <Small>
          <Flex alignItems="center" mb="3px">
            <Box
              width={'1.5em'}
              style={{ background: themify('green'), height: '1.5em', borderRadius: 6 }}
              mr={1}
            />
            <Box>Toegestaan, na 5 dagen is de woning vleermuisvrij</Box>
          </Flex>
          <Flex alignItems="center" mb="3px">
            <Box
              width={'1.5em'}
              style={{ background: themify('yellow'), height: '1.5em', borderRadius: 6 }}
              mr={1}
            />
            <Box>
              Effectiviteit vleermuiswerende maatregelen moet worden ingeschat door een ecoloog
            </Box>
          </Flex>
          <Flex alignItems="center" mb="3px">
            <Box
              width={'1.5em'}
              style={{ background: themify('orange'), height: '1.5em', borderRadius: 6 }}
              mr={1}
            />
            <Box>
              Winterperiode: toegestaan, maar de woning is pas vleermuisvrij na de winterperiode
            </Box>
          </Flex>
          <Flex alignItems="center" mb="3px">
            <Box
              width={'1.5em'}
              style={{ background: themify('red'), height: '1.5em', borderRadius: 6 }}
              mr={1}
            />
            <Box>Kraamperiode: niet toegestaan</Box>
          </Flex>
        </Small>
      </Box>
    </Flex>
  );
};

export default Natuurkalender;
